import { createReactBlockSpec } from "@blocknote/react";
import { InlineImage } from "../../components/InlineImage";
import { ImageWithChildrenBlock } from "./ImageWithChildrenBlock";

export const ImageWithChildrenBlockSpec = createReactBlockSpec(
  {
    type: "imageWithChildrenBlock",
    propSchema: {
      image: {
        default: "",
      },
      alt: {
        default: "",
      },
      url: {
        default: "",
      },
      caption: {
        default: "",
      },
      percentageWidth: {
        default: 50,
      },
      order: {
        default: "imageText",
        values: ["imageText", "textImage"] as const,
      },
    },
    content: "none",
    isSelectable: true,
  },
  {
    render: ({
      editor,
      block: {
        id,
        props: { image, alt, url, caption, percentageWidth, order },
      },
    }) => {
      const updateBlock = (
        newProps: Partial<{
          image: string;
          alt: string;
          url: string;
          caption: string;
          percentageWidth: number;
          order: "imageText" | "textImage";
        }>,
      ) => {
        // biome-ignore lint/suspicious/noExplicitAny:
        editor.updateBlock(id, { props: newProps as any });
      };

      return (
        <ImageWithChildrenBlock
          image={image}
          alt={alt}
          url={url}
          caption={caption}
          percentageWidth={percentageWidth}
          order={order}
          blockId={id}
          updateBlock={updateBlock}
        />
      );
    },
    toExternalHTML: ({ block }) => {
      const { image, alt, url, caption, percentageWidth, order } = block.props;
      const float = order === "imageText" ? "left" : "right";
      const margin = order === "imageText" ? { marginRight: "10px" } : { marginLeft: "10px" };

      return (
        <div className="ps-bn-image-with-children-image" style={{ width: `${percentageWidth}%`, float, ...margin }}>
          <InlineImage image={image} alt={alt} url={url} caption={caption} />
        </div>
      );
    },
  },
);
